export const iconFontAwesomeAccessibilityBraille = (
	<i className="fa-solid fa-braille"></i>
);
